<template>
	<div class="tmz-list-reports container mx-auto min-h-screen">
		<form v-on:keyup.enter="search()" v-on:submit.prevent v-if="accessLevel(USER.ouser.role, 3)">
				<div class="flex flex-row py-4 gap-10">
					<model-select
						class="w-4"
						:options="dzoList"
						v-model="selectedDzo"
						placeholder="ДЗО"
					></model-select>
					<model-select
						:options="years"
						v-model="selectedYear"
						placeholder="Год"
					></model-select>
					<model-select
						:options="months"
						v-model="selectedMonth"
						placeholder="Месяц"
					></model-select>
					<model-select
						:options="statuses"
						v-model="selectedStatus"
						placeholder="Статус"
					></model-select>

					<button
						class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
						@click="search()"
					>
						Поиск
					</button>
					<button
						class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
						@click="clearFilters()">
						Сбросить
					</button>
				</div>
			</form>

			<div class="table-container">
				<table>
					<thead>
						<tr>
							<th>№ п/п</th>
							<th>ДЗО</th>
<!--							<th>Отчет создан</th>-->
<!--							<th>Отчет утвержден</th>-->
							<th>Год</th>
							<th>Месяц</th>
							<th>Дата создания</th>
							<th>Статус</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(report, index) in reports"
							:key="report.id"
							@click="openReport(report.id)"
						>
							<td>{{ defineIndex(index) }}</td>
							<td>{{ report.dzo.name }}</td>
<!--							<td>-->
								<!--                        {{ report.create_user.first_name | TitleCase }}-->
								<!--                        {{ report.create_user.last_name | TitleCase }}-->
<!--							</td>-->
<!--							<td>-->
<!--								{{-->
<!--									report.approved_user-->
<!--										? report.approved_user.first_name-->
<!--										: '' | TitleCase-->
<!--								}}-->
<!--								{{-->
<!--									report.approved_user-->
<!--										? report.approved_user.last_name-->
<!--										: '-' | TitleCase-->
<!--								}}-->
<!--							</td>-->
							<td>{{ report.year }}</td>
							<td>{{ report.month | getMonth }}</td>
							<td>{{ report.created_datetime | formatDate }}</td>
							<td>
								<p
									class="my-report-status"
									:class="getBtnColor(report.status)"
								>
									<span v-if="report.status == 'Ошибка' || report.status == 'Ошибка_минус' || report.status == 'Создан' ">Не сдан</span>
									<span v-else>{{ report.status }}</span>
								</p>
							</td>
						</tr>
					</tbody>
				</table>
				<div
					class="empty-list"
					v-if="
						!emptyObject(this.tmzReports) &&
							accessLevel(USER.ouser.role, 1)
					"
				>
					<router-link
						class="create-report"
						:to="{ name: 'create-tmz-step-first' }"
						v-if="createAllowed"
					>
						Создать
					</router-link>
				</div>
			</div>

			<div class="tmz__pagination">
				<pagination v-if="this.pageCount > 1" :currentPage="this.page" :pageCount="this.pageCount" @pageClicked="search" />
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../../store';
import axios from 'axios';
import NProgress from 'nprogress';
import { ModelSelect } from 'vue-search-select';
import Pagination from '../../components/shared/Pagination.vue';

export default {
	name: 'TmzReports',
	components: {
		ModelSelect,
		Pagination
	},
	data() {
		return {
			page: 1,
			reports: [],
			selectedDzo: '',
			selectedMonth: '',
			selectedYear: '',
			selectedStatus: '',
			years: [
				{ value: 2021, text: '2021' },
				{ value: 2022, text: '2022' },
        { value: 2023, text: '2023' },
				{ value: 2024, text: '2024' },
				{ value: 2025, text: '2025' },
				{ value: 2026, text: '2026' },
			],
			months: [
				{ value: 1, text: 'Январь' },
				{ value: 2, text: 'Февраль' },
				{ value: 3, text: 'Март' },
				{ value: 4, text: 'Апрель' },
				{ value: 5, text: 'Май' },
				{ value: 6, text: 'Июнь' },
				{ value: 7, text: 'Июль' },
				{ value: 8, text: 'Август' },
				{ value: 9, text: 'Сентябрь' },
				{ value: 10, text: 'Октябрь' },
				{ value: 11, text: 'Ноябрь' },
				{ value: 12, text: 'Декабрь' },
			],
			statuses: [
				{
					value: 0,
					text: 'Не сдан'
				},
				{
					value: 1,
					text: 'Сдан'
				},
        {
          value: -1,
          text: 'Не создан'
        }
			]
		};
	},
	beforeRouteEnter(to, from, next) {
		NProgress.start();
		store.dispatch('getAllTmzReports', 1).then(() => {
			store.dispatch('getAllDzo')
			store.dispatch('addNotification', {
				type: 'success',
				message: 'Мои отчеты обновлены',
			});
			NProgress.done();
			next();
		});
	},
	methods: {
		defineIndex(index) {
			if (this.page == 1) {
				return index + 1
			} else {
				if (index == 9) {
					return `${this.page}0`
				} else {
					return `${this.page - 1}${index + 1}`
				}
			}
		},
		search(page = 1) {
			this.page = page

			let payload = {
				dzo_id: this.selectedDzo,
				year: this.selectedYear,
				month: this.selectedMonth,
				status: this.selectedStatus,
				page: page
			}

			// Filtering Object to pass non empty values
			let filteredPayload = Object.fromEntries(
				Object.entries(payload).filter(([key, value]) => value !== '')
			)


			axios
				.get('/tmz/all-tmz/', {
					params: filteredPayload
				})
				.then(response => {
					this.reports = response.data.results
					store.commit('setTmzReportsCount', response.data.count)
				})
				.then(response => {
					store.dispatch('addNotification', {
						type: 'success',
						message: 'Таблица обновлена',
					});
				})
				.catch(error => {
					store.dispatch('addNotification', {
						type: 'error',
						message: error.response.data,
					});
				});
		},
		clearFilters() {
			this.selectedDzo = ''
			this.selectedYear = ''
			this.selectedMonth = ''
			this.selectedStatus = ''
			this.page = 1
			this.search()
		},
		accessLevel(roles, level) {
			if (roles) {
				let arr = Object.keys(
					JSON.parse(JSON.stringify(this.USER.ouser.role))
				);
				for (const role in arr) {
					if (roles[role].access_level === level) {
						return true;
					}
				}
				return false;
			}
			return false;
		},
		emptyObject(someObject) {
			return Object.keys(someObject).length;
		},
		getAllTmzReports(page) {
			NProgress.start();
			this.$store.dispatch('getAllTmzReports', page)
				.then(response => {
					this.reports = response.results
				})
				.then(() => {
					NProgress.done();
				})
				.then(() => {
					this.$store.dispatch('addNotification', {
						type: 'success',
						message: 'Мои отчеты обновлены',
					});
				})

		},
		openReport(id) {
			const route = this.$router.resolve({
				name: 'view-tmz-step-first',
				params: { id: id },
			});
			window.open(route.href, '_blank');
		},
		getBtnColor(status) {
			let color = '';
			if (status === 'Подписан исполнителем') {
				color = 'status-yellow';
			} else if (status === 'Подписан утверждающим') {
				color = 'status-yellow';
			} else if (status === 'Редактирован') {
				color = 'status-yellow';
			} else if (status === 'Авто-изменения после корректировки') {
				color = 'status-yellow';
			} else if (status === 'Утвержден получателем КМГ') {
				color = 'status-blue';
			} else if (status === 'Отклонен утверждающим') {
				color = 'status-red';
			} else if (status === 'Отклонен получателем КМГ') {
				color = 'status-red';
			}
			return color;
		},
	},
	mounted() {
		// this.getAllTmzReports();
		this.reports = this.tmzReports
	},
	computed: {
		...mapGetters(['USER', 'tmzReports', 'createAllowed', 'dzoList', 'tmzReportsCount']),
		pageCount() {
			return Math.ceil(this.tmzReportsCount / 10)
		}
	},
};
</script>

<style scoped>
.tmz-list-reports {
	margin-top: 2rem;
}

.table-filter-container {
	margin: 2rem 0;
	display: flex;
	justify-content: center;
}

.t-filter-select-company {
	max-width: 300px;
	min-width: 200px;
	height: 60px;
	border: 1px solid #e3e3e3;
	border-radius: 10px;
	appearance: none;
	/* text-align: center; */
	/* margin: 0 auto; */
	padding: 1rem 2rem;
	font-size: 1.1rem;
	margin: 0 0.5rem;
}

.t-filter-select-company:focus {
	outline: none;
}

.table-filter-submit {
	width: 200px;
	height: 60px;
	background: #36429e;
	color: #fff;
	border: none;
	outline: none;
	border-radius: 10px;
	font-size: 1.2rem;
	cursor: pointer;
}

.report-actions {
	display: flex;
	justify-content: flex-end;
}

.download-btn {
	padding: 0.5rem 1rem;
	background: #36429e;
	color: #fff;
	border: none;
	outline: none;
	border-radius: 10px;
	font-size: 1.2rem;
	cursor: pointer;
}

.download-select {
	border: 1px solid #e3e3e3;
	border-radius: 10px;
	appearance: none;
	padding: 0.5rem 2rem;
	font-size: 1.1rem;
	margin: 0 0.5rem 1rem;
}

.download-select:focus {
	outline: none;
}

table {
	border-collapse: collapse;
	width: 100%;
	max-width: 1460px;
	padding: 1rem;
}

thead {
	background: #f3f5ff;
	height: 70px;
}

thead th:nth-child(1) {
	border-top-left-radius: 10px;
}

thead th:last-child {
	border-top-right-radius: 10px;
}

th {
	padding: 1rem;
	color: #565656;
}

tr {
	cursor: pointer;
}

tr:hover {
	background: #f3f5ff;
}

td {
	padding: 1rem;
	text-align: center;
	border: 1px solid #e3e3e3;
}

.my-report-status {
	/* background: #7AD38D; */
	padding: 0.5rem 2.5rem;
	border-radius: 5px;
	/* width: 180px; */
}

.status-green {
	background: #7ad38d;
	color: white;
}

.status-yellow {
	background: #ffbb56;
	color: white;
}

.status-red {
	background: #e86363;
	color: white;
}

.delete-reports-btn {
	padding: 0.5rem 2.5rem;
	border-radius: 5px;
	font-size: 1.1rem;
	border: none;
	background: #e86363;
	color: white;
	float: right;
	margin: 2rem 0;
	cursor: pointer;
}

.empty-list {
	padding-top: 2rem;
	text-align: center;
}

.create-report {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	cursor: pointer;
	font-size: 1.1rem;
	background: #36429e;
	color: white;
}

.tmz__pagination {
	margin-top: 1.5rem;
}
</style>
